import { render, staticRenderFns } from "./Senarai.vue?vue&type=template&id=2507365a&scoped=true&"
import script from "./Senarai.vue?vue&type=script&lang=js&"
export * from "./Senarai.vue?vue&type=script&lang=js&"
import style0 from "./Senarai.vue?vue&type=style&index=0&id=2507365a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2507365a",
  null
  
)

export default component.exports